import { deleteTemplate } from 'api/operations/productServiceV2';
import { makeAutoObservable, runInAction } from 'mobx';
import ModalDelegate from 'store/general/modalDelegate';

export class DeleteTemplateModalDelegate {
  private _modalDelegate = new ModalDelegate();
  private _templateId = '';
  private _productName = '';
  private _isModalLoading = false;

  public get isVisible(): boolean {
    return this._modalDelegate.isVisible;
  }

  public get productName(): string {
    return this._productName;
  }

  public get templateId(): string {
    return this._templateId;
  }

  public get isModalLoading(): boolean {
    return this._isModalLoading;
  }

  public open(templateId: string, productName: string): void {
    this._templateId = templateId;
    this._productName = productName;
    this._modalDelegate.open();
  }

  public close(): void {
    this._templateId = '';
    this._productName = '';
    this._modalDelegate.close();
  }

  public async deleteProductTemplate(): Promise<void> {
    const templateId = this._templateId;
    if (!templateId) return;

    this._isModalLoading = true;

    await deleteTemplate(templateId);
    runInAction(() => {
      this._isModalLoading = false;
    });
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
